import AsideMonetization from './AsideMonetization';

export default AsideMonetization;